import { ValidatorFn, AbstractControl, Validators } from '@angular/forms';

export function maxOptions(maxLength: number): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const result = Validators.maxLength(maxLength)(control);
    const isValid = !result?.maxlength;
    return isValid ? null : { custom: `Only ${maxLength} options are <strong>allowed</strong>` };
  };
}
